import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationType } from '../../enums/notificationType';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: true,
  imports: [MatIcon, CommonModule]
})
export class SnackBarComponent {
  NotificationType = NotificationType;
  private intervalId: any;
  private timeoutId: any;
  private startTime: number = Date.now();
  remaining: number = 0;
  countDown: number = 0;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { title: string; message: string; notificationType: NotificationType; duration: number | undefined },
    private snackBarRef: MatSnackBarRef<SnackBarComponent>,
    private cdr: ChangeDetectorRef
  ) {
    if (data.duration) {
      this.remaining = data.duration;
      this.countDown = this.remaining;
    }

    this.startTimer();
  }

  get notificationIcon(): string {
    switch (this.data.notificationType) {
      case NotificationType.Success:
        return 'check_circle_outline';
      case NotificationType.Warning:
        return 'error_outline';
      case NotificationType.Info:
        return 'info_outline';
      case NotificationType.Error:
      default:
        return 'error_outline';
    }
  }

  get notificationColor(): string {
    switch (this.data.notificationType) {
      case NotificationType.Success:
        return 'var(--success-500)';
      case NotificationType.Error:
        return 'var(--error-800)';
      case NotificationType.Warning:
        return '#FA9401';
      case NotificationType.Info:
      default:
        return 'var(--primary-500)';
    }
  }

  close() {
    this.snackBarRef.dismiss();
  }

  pauseTimer() {
    clearTimeout(this.timeoutId);
    clearInterval(this.intervalId);
    const elapsed = Date.now() - this.startTime;
    this.remaining -= elapsed;
    this.cdr.detectChanges();
  }

  resumeTimer() {
    this.startTimer();
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutId);
    clearInterval(this.intervalId);
  }

  private startTimer() {
    this.startTime = Date.now();

    if (this.data.duration) {
      this.timeoutId = setTimeout(() => {
        this.snackBarRef?.dismiss();
      }, this.remaining);
    }

    this.intervalId = setInterval(() => {
      this.countDown -= 10;
      this.cdr.detectChanges();
    }, 10);
  }
}
